// extracted by mini-css-extract-plugin
export default {"icon":"PricesCounter_icon__v8vl-"};